import { h} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';
import { MarkupText } from 'preact-i18n';
import { GetSafeImageUrl } from '../../utils/ApiUtil';

export const Entity = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  const [affid, setAffid] = useState(props.affid);
  if(!item || isNaN(item.resultIndex) || item.answerType !== "Entities") {
    return (""); //defensive check
  }
  let entityBlock = searchResp.entities.value[item.resultIndex];
  let entityType = (entityBlock.entityPresentationInfo && entityBlock.entityPresentationInfo.entityTypeHints) ? entityBlock.entityPresentationInfo.entityTypeHints[0] : "";
  let entityScenario = entityBlock.entityPresentationInfo.entityScenario;
  if(entityBlock === null || !entityType || entityType === "Generic") {
    return (""); //defensive check
  }
  return (
    <div>
      { entityScenario == "DisambiguationItem" ? 
        <DisambiguationEntity entityBlock={entityBlock} affid={affid}/> : 
        <DominantEntity entityBlock={entityBlock} affid={affid}/>
      }
    </div>
  )
}

export const DisambiguationEntity = props => {
  const [entityBlock, setEntityBlock] = useState(props.entityBlock);
  const [affid, setAffid] = useState(props.affid);
  let entityType = (entityBlock.entityPresentationInfo && entityBlock.entityPresentationInfo.entityTypeHints) ? entityBlock.entityPresentationInfo.entityTypeHints[0] : "";
  return (
    <div className="disambiguation-entity">
      <div className="entity-snippet-left">
        <div className="ae-title entity-title">
          <a href={`/search?q=${encodeURIComponent(entityBlock.name)}&affid=${encodeURIComponent(affid)}`}>
            <Markup markup={entityBlock.name + " (" + entityType + ") "} type="html" trim={false}/> 
          </a>
        </div>
        <div className="ae-para entity-description">
          <Markup markup={entityBlock.description ? entityBlock.description : ""} type="html" trim={false}/> 
        </div>
      </div>
      <div className="entity-snippet-right">
        <img src={GetSafeImageUrl(entityBlock.image && entityBlock.image.thumbnailUrl ? entityBlock.image.thumbnailUrl : "")} />
      </div>
    </div>
  )
}

export const DominantEntity = props => {
  const [entityBlock, setEntityBlock] = useState(props.entityBlock);
  const [affid, setAffid] = useState(props.affid);
  return (
    <div className="result-block result-entity ae-border-box">
      {entityBlock.image ? (
      <div className="entity-image">
        <img src={entityBlock.image.hostPageUrl ? entityBlock.image.hostPageUrl : GetSafeImageUrl(entityBlock.image.thumbnailUrl)} style={{maxWidth:"250px", height: "auto"}}/>
      </div>
      ):("")}
      <div className="entity-info">
        <div className="ae-headline entity-title">
          <Markup markup={entityBlock.name} type="html" trim={false}/> 
        </div>
        <div className="entity-classification">
          {(entityBlock.entityPresentationInfo && entityBlock.entityPresentationInfo.entityTypeHints) ? entityBlock.entityPresentationInfo.entityTypeHints[0] : ""}
        </div>
        <div className="ae-para entity-description">
          <Markup markup={entityBlock.description ? entityBlock.description : ""} type="html" trim={false}/>
        </div>
        <ContractualRules entityBlock={entityBlock}/>
      </div>
    </div>
  )
}

export const ContractualRules = props => {
  const [entityBlock, setEntityBlock] = useState(props.entityBlock);
  let attribution, licenseObj, attributionLinkString, licenseLinkString;
  if (entityBlock.contractualRules) {
    attribution = entityBlock.contractualRules.find(cr => cr._type === "ContractualRules/LinkAttribution")
    licenseObj = entityBlock.contractualRules.find(cr => cr._type === "ContractualRules/LicenseAttribution")
    attributionLinkString = attribution ? `<a class="ae-dark" href=${attribution.url}>${attribution.text}</a>` : "";
    licenseLinkString = licenseObj ? `<a class="ae-dark" href=${licenseObj.license.url}>${licenseObj.license.name}</a>` : "";
  }
  return (
    attribution && licenseObj
    ? ( 
      <MarkupText className="contractual-rule" id="newSearch.attributionLicense" fields={{ attributionField: attributionLinkString, licenseField: licenseLinkString }}>
        {attribution.text} text under {licenseObj.license.name} license
      </MarkupText>
    ) : 
    attribution 
    ? (
      <MarkupText className="contractual-rule" id="newSearch.attributionOnly" fields={{ attributionField: attributionLinkString }}>
        Data: {attribution.text}
      </MarkupText>
    ) :
    licenseObj 
    ? (
      <MarkupText className="contractual-rule" id="newSearch.licenseOnly" fields={{ licenseField: licenseLinkString }}>
        Text under {licenseObj.license.name} license
      </MarkupText>
    )
    :
    ""
  )
}
